<div class="row">
  <div class="col-12">
    <form
      [formGroup]="priceCalculationForm"
      class="lp-price-calculation-form-wrapper"
    >
      <div class="lp-countries-price-calculation-form-fi">
        <div class="lp-countries-price-calculation-form-control-wrapper">
          <label for="toCountry" class="input-label">From</label>

          <div class="lp-countries-hero-select-dropdown">
            <div class="lp-countries-hero-select-dropdown-input">
              <div class="lp-countries-hero-select-dropdown-input-flag">
                <img
                  src="https://www.shippn.com/assets/img/flags/{{
                    selectedFromCountry?.country_flag
                  }}"
                  alt="{{ selectedFromCountry?.name }}"
                />
              </div>
              <div class="lp-countries-hero-select-dropdown-input-country" (click)="showFromCountrySelection = !showFromCountrySelection">
                <strong>{{ selectedFromCountry?.name }}</strong>
              </div>
              <div class="lp-countries-hero-select-dropdown-input-control">
                <button
                aria-label="Select a country"
                  class="lp-countries-hero-select-dropdown-input-control-btn"
                  [ngClass]="
                    showFromCountrySelection ? 'rotate-180deg' : 'rotate-to-0'
                  "
                  (click)="showFromCountrySelection = !showFromCountrySelection"
                >
                  <img
                    src="assets/img/lp-countries/icons/arrow-right.png"
                    alt="lp countries arrow right icon"
                  />
                </button>
              </div>
            </div>

            <div
              class="lp-countries-hero-select-dropdown-selection"
              [ngClass]="
                showFromCountrySelection ? 'show-selection' : 'hide-selection'
              "
            >
              <div class="lp-countries-hero-select-dropdown-selection-list">
                <div
                  class="lp-countries-hero-select-dropdown-selection-list-item"
                  *ngFor="let country of fromCountriesList"
                  (click)="selectFromCountry(country?.code)"
                >
                  <img
                    src="https://www.shippn.com/assets/img/flags/{{
                      country?.country_flag
                    }}"
                    alt="{{ country?.name }} flag "
                  />
                  {{ country?.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lp-countries-price-calculation-form-control-wrapper">
          <label for="toCountry" class="input-label">To</label>

          <div class="lp-countries-hero-select-dropdown">
            <div class="lp-countries-hero-select-dropdown-input">
              <div class="lp-countries-hero-select-dropdown-input-flag">
                <img
                  src="https://www.shippn.com/assets/img/flags/{{
                    selectedCountry?.country_flag
                  }}"
                  alt="{{ selectedCountry?.name }}"
                />
              </div>
              <div class="lp-countries-hero-select-dropdown-input-country" (click)="showCountrySelection = !showCountrySelection">
                <strong>{{ selectedCountry?.name }}</strong>
              </div>
              <div class="lp-countries-hero-select-dropdown-input-control">
                <button
                aria-label="Select a country"
                  class="lp-countries-hero-select-dropdown-input-control-btn"
                  [ngClass]="
                    showCountrySelection ? 'rotate-180deg' : 'rotate-to-0'
                  "
                  (click)="showCountrySelection = !showCountrySelection"
                >
                  <img
                    src="assets/img/lp-countries/icons/arrow-right.png"
                    alt="lp countries arrow right icon"
                  />
                </button>
              </div>
            </div>

            <div
              class="lp-countries-hero-select-dropdown-selection"
              [ngClass]="
                showCountrySelection ? 'show-selection' : 'hide-selection'
              "
            >
              <div class="lp-countries-hero-select-dropdown-selection-list">
                <div
                  class="lp-countries-hero-select-dropdown-selection-list-item"
                  *ngFor="let country of countriesList"
                  (click)="selectToCountry(country?.code)"
                >
                  <img
                    src="https://www.shippn.com/assets/img/flags/{{
                      country?.country_flag
                    }}"
                    alt="{{ country?.name }} flag "
                  />
                  {{ country?.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>

      <div class="lp-countries-price-calculation-from-di">
        

        <div class="dimensions-form-controls">

          <div class="weight-form-controls">
            <div
              class="lp-countries-price-calculation-form-control-wrapper-weight-area"
            >
              <div class="weight-wrapper">
                <label for="weight" class="input-label">Weight</label>
                <input
                  autocomplete="off"
                  id="weight"
                  formControlName="weight"
                  type="string"
                  placeholder="Weight"
                  onchange="(function(el){el.value.replace(/[^0-9.,]/g, '');el.value=parseFloat(el.value).toFixed(2); el.value.replace(',', '.');})(this)"
                  onwheel="this.blur()"
                  (keydown)="checkKey($event)"
                  (focusout)="checkValue($event)"
                  (paste)="onPaste($event)"
                />
              </div>
  
              <div class="weight-unit-wrapper">
                <div class="toggle-switch">
                  <input
                    type="radio"
                    id="lb"
                    name="weightUnit"
                    [value]="'lb'"
                    formControlName="weightUnit"
                  />
                  <input
                    type="radio"
                    id="kg"
                    name="weightUnit"
                    [value]="'kg'"
                    formControlName="weightUnit"
                  />
                  <label for="lb" class="switch-label lb-label">lb</label>
                  <label for="kg" class="switch-label kg-label">kg</label>
                  <span class="switch-slider"></span>
                </div>
              </div>
            </div>
          </div>

          <div class="lp-countries-price-calculation-form-control-wrapper">
            <label for="length" class="input-label">Length</label>
            <input
              autocomplete="off"
              id="length"
              formControlName="length"
              type="string"
              placeholder="Length"
              onchange="(function(el){el.value.replace(/[^0-9.,]/g, '');el.value=parseFloat(el.value).toFixed(2); el.value.replace(',', '.');})(this)"
              onwheel="this.blur()"
              (keydown)="checkKey($event)"
              (focusout)="checkValue($event)"
              (paste)="onPaste($event)"
              tabindex="1"
            />
          </div>
          <div class="lp-countries-price-calculation-form-control-wrapper">
            <label for="width" class="input-label">Width</label>
            <input
              autocomplete="off"
              id="width"
              formControlName="width"
              placeholder="Width"
              type="string"
              onchange="(function(el){el.value.replace(/[^0-9.,]/g, '');el.value=parseFloat(el.value).toFixed(2); el.value.replace(',', '.');})(this)"
              onwheel="this.blur()"
              (keydown)="checkKey($event)"
              (focusout)="checkValue($event)"
              (paste)="onPaste($event)"
              tabindex="2"
            />
          </div>
          <div class="lp-countries-price-calculation-form-control-wrapper">
            <label for="height" class="input-label">Height</label>
            <input
              autocomplete="off"
              id="height"
              formControlName="height"
              placeholder="Height"
              type="string"
              onchange="(function(el){el.value.replace(/[^0-9.,]/g, '');el.value=parseFloat(el.value).toFixed(2); el.value.replace(',', '.');})(this)"
              onwheel="this.blur()"
              (keydown)="checkKey($event)"
              (focusout)="checkValue($event)"
              (paste)="onPaste($event)"
              tabindex="3"
            />
          </div>
          <div class="lp-countries-price-calculation-form-control-wrapper">
            <div class="dimensions-unit-wrapper">
              <div class="toggle-switch">
                <input
                  type="radio"
                  id="in"
                  name="dimensionsUnit"
                  [value]="'in'"
                  formControlName="dimensionsUnit"
                />
                <input
                  type="radio"
                  id="cm"
                  name="dimensionsUnit"
                  [value]="'cm'"
                  formControlName="dimensionsUnit"
                />
                <label for="in" class="switch-label in-label">in</label>
                <label for="cm" class="switch-label cm-label">cm</label>
                <span class="switch-slider"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="lp-price-calculation-form-submit">
        <button
          type="submit"
          (click)="onSubmit()"
          class="lp-price-calculation-form-submit-btn"
          aria-label="Get an Estimate of the cost of shipping"
          >
          Get Estimate
        </button>
      </div>
    </form>
  </div>
</div>

<div class="row" *ngIf="priceCalculationResultData?.length > 0">
  <div class="col-12">
    <div class="price-calculation-result-wrapper">
      <div class="price-calculation-result-data">
        <div class="price-calculation-result-data-header">
          <div>
            <h6>Courier</h6>
          </div>
          <div>
            <h6>Service Type</h6>
          </div>
          <div>
            <h6>Estimated Delivery</h6>
          </div>
          <div>
            <h6>Cost (including host fee)</h6>
          </div>
        </div>
        <div
          class="price-calculation-result-data-item"
          *ngFor="let courier of priceCalculationResultData"
        >
          <div class="courier-company">
            <img
              *ngIf="courier.company_id == 1"
              src="../../assets/tnt.png"
              alt="tnt logo"
            />
            <img
              *ngIf="courier.company_id == 2"
              src="../../assets/ups.png"
              alt="ups logo"
            />
            <img
              *ngIf="courier.company_id == 3"
              src="../../assets/dhl.png"
              alt="dhl logo"
            />
            <img
              *ngIf="courier.company_id == 4"
              src="../../assets/fedex.png"
              alt="fedex logo"
            />
            <img
              *ngIf="courier.company_id == 5"
              src="../../assets/auspost.png"
              alt="auspost logo"
            />
            <img
              *ngIf="courier.company_id == 6"
              src="../../assets/usps.png"
              alt="usps logo"
            />
            <img
              *ngIf="courier.company_id == 7"
              src="../../assets/aramex.png"
              alt="aramex logo"
            />
            <img
              *ngIf="courier.company_id == 8"
              src="../../assets/laposte.png"
              alt="laposte logo"
            />
            <img
              *ngIf="courier.company_id == 12"
              src="../../assets/ems.png"
              alt="Shippn Partner EMS logo"
              style="max-height: 40px;"
            />
            <img
              *ngIf="courier.company_id == 13"
              src="../../assets/dpd.png"
              alt="Courier DPD logo"
            />
            <img
              *ngIf="courier.company_id == 14"
              src="../../assets/evri.webp"
              alt="Courier Evri logo"
            />
          </div>
          <div class="courier-service-type">
            {{ courier.service_type_name }}
          </div>
          <div class="courier-estimated-delivery-time">
            {{ courier.estimated_delivery }} Business Days
          </div>

          <div class="courier-cost">
            {{ courier.total_shipment_amount }} USD
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <button
          type="submit"
          (click)="goToSignUp()"
          class="lp-price-calculation-form-submit-btn" style="margin: 30px auto 0;"
          aria-label="Sign Up and Book">
          Sign Up & Book
        </button>
  </div>
</div>
